import { Component, inject, OnInit } from '@angular/core';
import { Article } from '../../models/article.model';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ArticlesService } from '../../services/articles.service';
import { ToastService } from '../../services/toast.service';
import { DatePipe } from '@angular/common';
import { Category } from '../../models/category.model';
import { CategoriesService } from '../../services/categories.service';
import { DynamicContentViewerComponent } from '../../components/dynamic-content-viewer/dynamic-content-viewer.component';

@Component({
  selector: 'app-article-details',
  imports: [RouterLink, DatePipe, DynamicContentViewerComponent],
  templateUrl: './article-details.component.html',
  styles: `
    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }
  `
})
export class ArticleDetailsComponent implements OnInit {
  article?: Article | null;
  articles: Article[] = [];
  articleId?: string;
  subcategories: Category[] = [];

  private route = inject(ActivatedRoute);
  private articlesService = inject(ArticlesService);
  private categoriesService = inject(CategoriesService);
  private toast = inject(ToastService);
  private router = inject(Router);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.articleId = params.get('id')!;
      this.getArticle();
    });

    this.getSubcategories();
  }

  getArticle() {
    this.article = null;
    this.articles = [];

    this.articlesService.get(this.articleId!).subscribe({
      next: (res) => {
        this.article = res.data;
        this.getArticles();
      },
      error: (error) => {
        this.toast.error(error);
        this.router.navigateByUrl('/articulos');
      }
    });
  }

  getArticles() {
    this.articlesService.getAll().subscribe((res) => {
      this.articles = res.data.records
        .filter((article: Article) => article.id !== this.article?.id)
        .slice(0, 4);
    });
  }

  getSubcategories() {
    this.categoriesService.getAll().subscribe((categories) => {
      this.subcategories = categories.data.flatMap(
        (category: Category) => category.subcategories
      );
    });
  }

  getSubcategoryName(id: number): string {
    const subcategory = this.subcategories.find((s) => s.id === id);
    return subcategory ? subcategory.name : 'N/A';
  }
}
